/**
 * Trạng thái đồng bộ khách hàng lên AMIS/Misa — dùng chung cho cột "ĐB Misa"
 * ở màn Khách hàng và dropdown tìm khách ở POS (TCR-1566).
 *
 * Logic KHỚP đúng BE (`CustomerService.list()`), giữ nguyên từ
 * `pages/Customers/parts/columns.tsx` khi tách ra dùng chung:
 * TCR-1559 đổi tín hiệu "synced" từ `amis_pushed_at` (chỉ set khi worker tự
 * đẩy thành công) sang `amis_account_object_id` (đã có mã đối tượng AMIS thật,
 * kể cả từ luồng import/đồng bộ về) — trước đây badge hiện "Chưa đồng bộ" cho
 * phần lớn khách đã thực sự đồng bộ, vì `amis_pushed_at` gần như không bao giờ
 * được set.
 */
export type AmisSyncStatus = 'synced' | 'pending' | 'not_synced';

/** Shape tối thiểu để suy ra trạng thái — cả TenantCustomer lẫn item tìm khách POS đều khớp. */
export interface AmisSyncFields {
  amis_account_object_id?: string | null;
  amis_push_pending_at?: string | null;
  amis_push_blocked_reason?: string | null;
}

export function deriveAmisSyncStatus(row: AmisSyncFields): AmisSyncStatus {
  if (row.amis_push_blocked_reason) return 'not_synced';
  if (!row.amis_account_object_id) return 'not_synced';
  if (row.amis_push_pending_at) return 'pending';
  return 'synced';
}

/** Nhãn + màu Tag antd, để hai màn hiển thị y hệt nhau. */
export const AMIS_SYNC_STATUS_LABEL: Record<AmisSyncStatus, string> = {
  synced: 'Đã đồng bộ',
  pending: 'Chờ đồng bộ lại',
  not_synced: 'Chưa đồng bộ',
};

export const AMIS_SYNC_STATUS_COLOR: Record<AmisSyncStatus, string> = {
  synced: 'green',
  pending: 'orange',
  not_synced: 'default',
};
